import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import classNames from 'classnames';

import { getAsset } from '../../../../../../../../../util/assets';
import Button from '../../../../../../../../../components/global/Button';

const propTypes = {
  className: PropTypes.string,
  printCategory: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    asset_image: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
    print_products: PropTypes.shape({
      total: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  onPrintCategorySelect: PropTypes.func.isRequired,
};

const PrintCategoryOption = ({
  className,
  printCategory,
  readOnly,
  onPrintCategorySelect,
}) => {
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-print-category': true,
  });

  const previewImage = printCategory.asset_image?.url;

  return (
    <div className={classes}>
      <div className="purchasing-option-item-thumb">
        <img
          width={previewImage ? 80 : 60}
          src={previewImage || getAsset('/simple-prints-illustration.svg')}
          alt=""
        />
      </div>

      <div className="purchasing-option-item-content-wrap">
        <span className="purchasing-option-item-title">
          {printCategory.name}
        </span>
        <div className="purchasing-option-item-info-extra">
          <span className="text-primary text-sm text-extra-bold">
            {printCategory.print_products.total}{' '}
            {pluralize('product', printCategory.print_products.total)}
          </span>
        </div>

        {!readOnly && (
          <Button
            className={classNames({
              'purchasing-options-item-btn': true,
              'mt-2': true,
            })}
            data-testid="btn-print-product-shop"
            onClick={() => {
              onPrintCategorySelect(printCategory);
            }}
          >
            Shop
          </Button>
        )}
      </div>
    </div>
  );
};

PrintCategoryOption.propTypes = propTypes;

export default PrintCategoryOption;
